import moment from "moment";
/** @description does not support duration in seconds longer than 1 day  */
export var getTimeFromSeconds = function (seconds) {
    var formattedTime = moment.utc(moment.duration(seconds, "seconds").as("milliseconds")).format("HH:mm:ss");
    return formattedTime;
};
